import { Action, Dispatch } from 'redux'
import { State } from 'index'
import { toggleSubHeaderAction } from 'reducks/nav/actions'

const toggleSubHeader = () => {
  return async (dispatch: Dispatch<Action>, getState: () => State) => {
    const prevState = getState().nav.sub_header.open
    dispatch(toggleSubHeaderAction(!prevState))
  }
}

export default toggleSubHeader
